import { Tab, Tabs, TabsProps, useTheme } from "@mui/material"
import { useEffect, useState } from "react"
import { FaqTags } from "../../../types"

interface FaqNavigationTabsProps extends TabsProps {
    items: FaqTags[]
    selectedIndex: number
    onTabChange: (event: React.SyntheticEvent, newIndex: number) => void
}

const FaqNavigationTabs = (props: FaqNavigationTabsProps) => {
    const { items, selectedIndex, onTabChange, ...inheritedProps } = props

    const [selectedTabValue, setSelectedTabValue] = useState(0)
    const theme = useTheme()

    const handleTabChange = (event: React.SyntheticEvent, newIndex: number) => {
        setSelectedTabValue(newIndex)
        onTabChange?.(event, newIndex)
    }

    useEffect(() => {
        setSelectedTabValue(selectedIndex)
    }, [selectedIndex])

    const getTabId = (item: FaqTags): string => {
        return `tab-item-${item.id}`
    }

    const tabColor = {'&.Mui-selected': {color : `${theme.palette.secondary.main}`} }
    const indicatorColor = {'& .MuiTabs-indicator': { backgroundColor: `${theme.palette.secondary.main}` } }

    const renderTab = (items: FaqTags[]) => {
        return items.map(item => {
            return <Tab id={getTabId(item)} label={item.tag} key={getTabId(item)} sx={tabColor}/>
        })
    }

    return (
        <Tabs value={selectedTabValue} onChange={handleTabChange} scrollButtons={false} sx={indicatorColor} variant="scrollable" aria-label="faq tags" {...inheritedProps} >
            {renderTab(items)}
        </Tabs>
    )
}

export default FaqNavigationTabs